import { AuthenticationFacade, AuthenticationFacadeFactory, Authenticator, DefaultTokenGenerator, Ed25519TokenBodyParser, TokenParser, } from '@dialectlabs/sdk';
import { SolanaEd25519TokenValidator } from './solana-ed25519-token-validator';
export class SolanaEd25519AuthenticationFacadeFactory extends AuthenticationFacadeFactory {
    constructor(tokenSigner) {
        super();
        this.tokenSigner = tokenSigner;
    }
    static createAuthenticator() {
        return new Authenticator(new TokenParser(new Ed25519TokenBodyParser()), new SolanaEd25519TokenValidator());
    }
    get() {
        return new AuthenticationFacade(this.tokenSigner, new DefaultTokenGenerator(this.tokenSigner), SolanaEd25519AuthenticationFacadeFactory.createAuthenticator());
    }
}
//# sourceMappingURL=solana-ed25519-authentication-facade-factory.js.map